import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
/**
 * Returns the full or first name of a user when at least the first name
 * exists, otherwise returns null so that a fallback (for example the email
 * address) can be displayed instead.
 *
 * @param {object} user
 * @param {string} user.first_name
 * @param {string} user.last_name
 * @returns {string} Full or first name, or null
 */

function getFullUserName() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    first_name = _ref.first_name,
    last_name = _ref.last_name;
  if (first_name && last_name) {
    return "".concat(first_name, " ").concat(last_name).trim();
  }
  return first_name || undefined;
}
export default getFullUserName;